import React from "react";
import { getRouletteNumberAsset } from "./rouletteNumberAssets";

function RouletteLatestPanel({ latestResults }) {
  const results = Array.isArray(latestResults)
    ? latestResults.slice(0, 8)
    : [];

  return (
    <aside
      className="roulette-latest-panel"
      aria-label="Latest roulette results"
    >
      <div className="roulette-latest-panel-title">LATEST</div>

      <div className="roulette-latest-panel-list">
        {results.map((result, index) => {
          const src = getRouletteNumberAsset(result);

          return (
            <div
              className="roulette-latest-panel-item"
              key={`${result}-${index}`}
              title={String(result)}
            >
              {src && (
                <img
                  src={src}
                  alt={`Roulette result ${result}`}
                  draggable="false"
                />
              )}
            </div>
          );
        })}
      </div>
    </aside>
  );
}

export default RouletteLatestPanel;
